<template>
  <div class="admin-settings">
    <header-title :title="title"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <v-container fluid>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Colores Principales</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>General</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Principal : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.general.primaryColor"
              label="Color Principal"
              placeholder="E.g. #BA846B"
              @input="onChangeColor('generalPrimary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="generalPrimary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="generalPrimary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('generalPrimary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Segundario : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.general.secondaryColor"
              label="Color Segundario"
              placeholder="E.g. #A83620"
              @input="onChangeColor('generalSecondary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="generalSecondary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="generalSecondary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('generalSecondary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Comida</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Principal : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.comida.primaryColor"
              label="Color Principal"
              placeholder="E.g. #BA846B"
              @input="onChangeColor('comidaPrimary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="comidaPrimary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="comidaPrimary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('comidaPrimary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Segundario : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.comida.secondaryColor"
              label="Color Segundario"
              placeholder="E.g. #A83620"
              @input="onChangeColor('comidaSecondary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="comidaSecondary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="comidaSecondary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('comidaSecondary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Bebida</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Principal : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.bebida.primaryColor"
              label="Color Principal"
              placeholder="E.g. #ACDCD2"
              @input="onChangeColor('bebidaPrimary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="bebidaPrimary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="bebidaPrimary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('bebidaPrimary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Segundario : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.bebida.secondaryColor"
              label="Color Segundario"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('bebidaSecondary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="bebidaSecondary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="bebidaSecondary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('bebidaSecondary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Postre</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Principal : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.postre.primaryColor"
              label="Color Principal"
              placeholder="E.g. #ACDCD2"
              @input="onChangeColor('postrePrimary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="postrePrimary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="postrePrimary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('postrePrimary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Color Segundario : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.colors.postre.secondaryColor"
              label="Color Segundario"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('postreSecondary')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="postreSecondary" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="postreSecondary"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('postreSecondary')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <br />

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b> Tema de Cartas Principales</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <br />

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Ancho del logotipo :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.logoWidth"
              label="Ancho del logotipo"
              placeholder="E.g. 50"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Altura del logotipo :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.logoHeight"
              label="Altura del logotipo"
              placeholder="E.g. 40"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Borde de los botones (50 redondeado, 0 cuadrado) :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.buttonBorderRadius"
              label="Radio del borde del botón"
              placeholder="E.g. 10"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color Titulo de Carta :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.titleLetterColor"
              label="Color Titulo de Carta"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('titleLetterColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="titleLetterColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="titleLetterColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('titleLetterColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Colores de la barra de Menú :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.oddColor"
              label="Colores de la barra de Menú"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('oddColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="oddColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="oddColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('oddColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de fondo del carrito :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.cartBackgroudColor"
              label="Color de fondo del carrito"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('cartBackgroudColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="cartBackgroudColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="cartBackgroudColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('cartBackgroudColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color superior del borde del carrito :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.cartBorderTopColor"
              label="Color superior del borde del carrito"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('cartBorderTopColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="cartBorderTopColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="cartBorderTopColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('cartBorderTopColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color del título de la sección :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.sectionTitleColor"
              label="Color del título de la sección"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('sectionTitleColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="sectionTitleColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="sectionTitleColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('sectionTitleColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color del nombre de los productos :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.listItemNameColor"
              label="Color del nombre de los productos"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('listItemNameColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="listItemNameColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="listItemNameColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('listItemNameColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la descripción de los productos :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.listItemDescriptionColor"
              label="Color de la descripción de los productos"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('listItemDescriptionColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="listItemDescriptionColor" dark v-on="on">
                </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="listItemDescriptionColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('listItemDescriptionColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color del precio de los productos :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.listItemPriceColor"
              label="Color del precio de los productos"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('listItemPriceColor')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="listItemPriceColor" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="listItemPriceColor"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('listItemPriceColor')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <br />

        <v-row>
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Panel de Admin</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <br />

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Título de la páginas :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.pageTitle"
              label="Título de la páginas"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('pageTitle')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="pageTitle" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="pageTitle"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('pageTitle')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Texto del encabezado de las tablas :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.tableHeaderText"
              label="Texto del encabezado de la tablas"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('tableHeaderText')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="tableHeaderText" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="tableHeaderText"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('tableHeaderText')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Valor de dentro de la tablas :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.tableValues"
              label="Valor de dentro de la tablas"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('tableValues')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="tableValues" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="tableValues"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('tableValues')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Nombre de los valores de los formularios :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.formLabel"
              label="Nombre de los valores de los formularios"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('formLabel')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="formLabel" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="formLabel"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('formLabel')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta categoría :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.categoryTagBackground"
              label="Color de la etiqueta categoría"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('categoryTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="categoryTagBackground" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="categoryTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('categoryTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta subcategoría :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.subCategoryTagBackground"
              label="Color de la etiqueta subcategoría"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('subCategoryTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="subCategoryTagBackground" dark v-on="on">
                </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="subCategoryTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('subCategoryTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta bebida :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.drinksTagBackground"
              label="Color de la etiqueta bebida"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('drinksTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="drinksTagBackground" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="drinksTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('drinksTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta comida :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.foodTagBackground"
              label="Color de la etiqueta comida"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('foodTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="foodTagBackground" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="foodTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('foodTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta postre :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.dessertTagBackground"
              label="Color de la etiqueta postre"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('dessertTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="dessertTagBackground" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                value="#ba87a7"
                v-model="dessertTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('dessertTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1">
              Color de la etiqueta precio :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.themes.priceTagBackground"
              label="Color de la etiqueta precio"
              placeholder="E.g. #E2E1C7"
              @input="onChangeColor('priceTagBackground')"
            ></v-text-field>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :color="priceTagBackground" dark v-on="on"> </v-btn>
              </template>
              <v-color-picker
                :value="colorPickerDefault"
                v-model="priceTagBackground"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
                @input="changeColor('priceTagBackground')"
              ></v-color-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center">
            <div class="my-2 mr-5">
              <v-btn
                dense
                outlined
                @click="onSaveSetting"
                type="button"
                :style="adminNavigationBackTheme"
              >
                Guardar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import firebaseMixin from "../../../mixins/firebase/firebaseMixin";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { getSettingById, updateSetting } from "@/collections/settings";

export default {
  name: "Settings-Theme",
  components: { Loader, HeaderTitle },
  mixins: [firebaseMixin],
  data() {
    return {
      dialogLoader: false,
      title: "Plantilla y colores",
      colorPickerDefault: "#7417BE",
      input: {
        colors: {
          general: {
            primaryColor: "",
            secondaryColor: ""
          },
          comida: {
            primaryColor: "",
            secondaryColor: ""
          },
          bebida: {
            primaryColor: "",
            secondaryColor: ""
          },
          postre: {
            primaryColor: "",
            secondaryColor: ""
          }
        },
        themes: {
          logoWidth: "",
          logoHeight: "",
          buttonBorderRadius: "50px",
          cartBackgroudColor: "",
          cartBorderTopColor: "",
          pageTitle: "",
          tableHeaderText: "",
          tableValues: "",
          formLabel: "",
          categoryTagBackground: "",
          subCategoryTagBackground: "",
          drinksTagBackground: "",
          priceTagBackground: "",
          sectionTitleColor: "",
          dessertTagBackground: "",
          bebidaButtonBackgroudOdd: "",
          listItemNameColor: "",
          listItemPriceColor: "",
          listItemDescriptionColor: "",
          oddColor: "",
          titleLetterColor: ""
        }
      },
      generalPrimary: "#000",
      generalSecondary: "#fff",
      comidaPrimary: "",
      comidaSecondary: "",
      bebidaPrimary: "",
      bebidaSecondary: "",
      postrePrimary: "",
      postreSecondary: "",
      menuPrimary: "",
      menuSecondary: "",
      cartBackgroudColor: "#d4c9a9",
      cartBorderTopColor: "#000",
      pageTitle: "#000",
      tableHeaderText: "#000",
      tableValues: "#000",
      formLabel: "#000",
      categoryTagBackground: "#1976d2",
      subCategoryTagBackground: "#82b1ff",
      drinksTagBackground: "#424242",
      foodTagBackground: "#1976d2",
      dessertTagBackground: "#ba87a7",
      priceTagBackground: "#424242",
      sectionTitleColor: "#000",
      listItemNameColor: "#000",
      listItemPriceColor: "#0c0c0c",
      listItemDescriptionColor: "#000000",
      oddColor: "#000",
      allPaymentMethod: [
        {
          label: "Stripe",
          value: "stripe"
        },
        {
          label: "Redsys",
          value: "redsys"
        }
      ],
      titleLetterColor: "#000"
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.colors === undefined) {
          self.input = {
            ...self.input,
            colors: {
              general: {
                primaryColor: "",
                secondaryColor: ""
              },
              comida: {
                primaryColor: "",
                secondaryColor: ""
              },
              bebida: {
                primaryColor: "",
                secondaryColor: ""
              },
              postre: {
                primaryColor: "",
                secondaryColor: ""
              }
            }
          };
        }
        if (self.input.themes === undefined) {
          self.input = {
            ...self.input,
            themes: {
              logoWidth: "",
              logoHeight: "",
              buttonBorderRadius: "",
              cartBackgroudColor: "",
              cartBorderTopColor: "",
              pageTitle: "",
              tableHeaderText: "",
              tableValues: "",
              formLabel: "",
              categoryTagBackground: "",
              subCategoryTagBackground: "",
              drinksTagBackground: "",
              priceTagBackground: "",
              sectionTitleColor: "",
              dessertTagBackground: "",
              listItemNameColor: "",
              listItemPriceColor: "",
              listItemDescriptionColor: "",
              oddColor: "",
              titleLetterColor: ""
            }
          };
        }

        this.generalPrimary = this.input.colors.general.primaryColor;
        this.generalSecondary = this.input.colors.general.secondaryColor;
        this.comidaPrimary = this.input.colors.comida.primaryColor;
        this.comidaSecondary = this.input.colors.comida.secondaryColor;
        this.bebidaPrimary = this.input.colors.bebida.primaryColor;
        this.bebidaSecondary = this.input.colors.bebida.secondaryColor;
        this.postrePrimary = this.input.colors.postre.primaryColor;
        this.postreSecondary = this.input.colors.postre.secondaryColor;

        this.cartBackgroudColor = this.input.themes.cartBackgroudColor;
        this.cartBorderTopColor = this.input.themes.cartBorderTopColor;
        this.pageTitle = this.input.themes.pageTitle;
        this.tableHeaderText = this.input.themes.tableHeaderText;
        this.tableValues = this.input.themes.tableValues;
        this.formLabel = this.input.themes.formLabel;
        this.categoryTagBackground = this.input.themes.categoryTagBackground
          ? this.input.themes.categoryTagBackground
          : this.this.categoryTagBackground;
        this.subCategoryTagBackground = this.input.themes
          .subCategoryTagBackground
          ? this.input.themes.subCategoryTagBackground
          : this.subCategoryTagBackground;
        this.drinksTagBackground = this.input.themes.drinksTagBackground
          ? this.input.themes.drinksTagBackground
          : this.drinksTagBackground;
        this.foodTagBackground = this.input.themes.foodTagBackground
          ? this.input.themes.foodTagBackground
          : this.foodTagBackground;
        this.dessertTagBackground = this.input.themes.dessertTagBackground
          ? this.input.themes.dessertTagBackground
          : this.dessertTagBackground;
        this.priceTagBackground = this.input.themes.priceTagBackground
          ? this.input.themes.priceTagBackground
          : this.priceTagBackground;
        this.sectionTitleColor = this.input.themes.sectionTitleColor;

        this.listItemNameColor = this.input.themes.listItemNameColor
          ? this.input.themes.listItemNameColor
          : this.listItemNameColor;
        this.listItemPriceColor = this.input.themes.listItemPriceColor
          ? this.input.themes.listItemPriceColor
          : this.listItemPriceColor;
        this.listItemDescriptionColor = this.input.themes
          .listItemDescriptionColor
          ? this.input.themes.listItemDescriptionColor
          : this.listItemDescriptionColor;
        this.oddColor = this.input.themes.oddColor
          ? this.input.themes.oddColor
          : this.oddColor;
        this.titleLetterColor = this.input.themes.titleLetterColor
          ? this.input.themes.titleLetterColor
          : this.titleLetterColor;
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    },
    changeColor(type) {
      switch (type) {
        case "generalPrimary":
          this.input.colors.general.primaryColor = this.generalPrimary;
          break;
        case "generalSecondary":
          this.input.colors.general.secondaryColor = this.generalSecondary;
          break;
        case "comidaPrimary":
          this.input.colors.comida.primaryColor = this.comidaPrimary;
          break;
        case "comidaSecondary":
          this.input.colors.comida.secondaryColor = this.comidaSecondary;
          break;
        case "bebidaPrimary":
          this.input.colors.bebida.primaryColor = this.bebidaPrimary;
          break;
        case "bebidaSecondary":
          this.input.colors.bebida.secondaryColor = this.bebidaSecondary;
          break;
        case "postrePrimary":
          this.input.colors.postre.primaryColor = this.postrePrimary;
          break;
        case "postreSecondary":
          this.input.colors.postre.secondaryColor = this.postreSecondary;
          break;
        case "cartBackgroudColor":
          this.input.themes.cartBackgroudColor = this.cartBackgroudColor;
          break;
        case "cartBorderTopColor":
          this.input.themes.cartBorderTopColor = this.cartBorderTopColor;
          break;
        case "pageTitle":
          this.input.themes.pageTitle = this.pageTitle;
          break;
        case "tableHeaderText":
          this.input.themes.tableHeaderText = this.tableHeaderText;
          break;
        case "tableValues":
          this.input.themes.tableValues = this.tableValues;
          break;
        case "formLabel":
          this.input.themes.formLabel = this.formLabel;
          break;
        case "categoryTagBackground":
          this.input.themes.categoryTagBackground = this.categoryTagBackground;
          break;
        case "subCategoryTagBackground":
          this.input.themes.subCategoryTagBackground = this.subCategoryTagBackground;
          break;
        case "drinksTagBackground":
          this.input.themes.drinksTagBackground = this.drinksTagBackground;
          break;
        case "foodTagBackground":
          this.input.themes.foodTagBackground = this.foodTagBackground;
          break;
        case "dessertTagBackground":
          this.input.themes.dessertTagBackground = this.dessertTagBackground;
          break;
        case "priceTagBackground":
          this.input.themes.priceTagBackground = this.priceTagBackground;
          break;
        case "sectionTitleColor":
          this.input.themes.sectionTitleColor = this.sectionTitleColor;
          break;
        case "listItemNameColor":
          this.input.themes.listItemNameColor = this.listItemNameColor;
          break;
        case "listItemPriceColor":
          this.input.themes.listItemPriceColor = this.listItemPriceColor;
          break;
        case "listItemDescriptionColor":
          this.input.themes.listItemDescriptionColor = this.listItemDescriptionColor;
          break;
        case "oddColor":
          this.input.themes.oddColor = this.oddColor;
          break;
        case "titleLetterColor":
          this.input.themes.titleLetterColor = this.titleLetterColor;
          break;
      }
    },
    onChangeColor(type) {
      switch (type) {
        case "generalPrimary":
          this.generalPrimary = this.input.colors.general.primaryColor;
          break;
        case "generalSecondary":
          this.generalSecondary = this.input.colors.general.secondaryColor;
          break;
        case "comidaPrimary":
          this.comidaPrimary = this.input.colors.comida.primaryColor;
          break;
        case "comidaSecondary":
          this.comidaSecondary = this.input.colors.comida.secondaryColor;
          break;
        case "bebidaPrimary":
          this.bebidaPrimary = this.input.colors.bebida.primaryColor;
          break;
        case "bebidaSecondary":
          this.bebidaSecondary = this.input.colors.bebida.secondaryColor;
          break;
        case "postrePrimary":
          this.postrePrimary = this.input.colors.postre.primaryColor;
          break;
        case "postreSecondary":
          this.postreSecondary = this.input.colors.postre.secondaryColor;
          break;
        case "cartBackgroudColor":
          this.cartBackgroudColor = this.input.themes.cartBackgroudColor;
          break;
        case "cartBorderTopColor":
          this.cartBorderTopColor = this.input.themes.cartBorderTopColor;
          break;
        case "pageTitle":
          this.pageTitle = this.input.themes.pageTitle;
          break;
        case "tableHeaderText":
          this.tableHeaderText = this.input.themes.tableHeaderText;
          break;
        case "tableValues":
          this.tableValues = this.input.themes.tableValues;
          break;
        case "formLabel":
          this.formLabel = this.input.themes.formLabel;
          break;
        case "categoryTagBackground":
          this.categoryTagBackground = this.input.themes.categoryTagBackground;
          break;
        case "subCategoryTagBackground":
          this.subCategoryTagBackground = this.input.themes.subCategoryTagBackground;
          break;
        case "drinksTagBackground":
          this.drinksTagBackground = this.input.themes.drinksTagBackground;
          break;
        case "foodTagBackground":
          this.foodTagBackground = this.input.themes.foodTagBackground;
          break;
        case "dessertTagBackground":
          this.dessertTagBackground = this.input.themes.dessertTagBackground;
          break;
        case "priceTagBackground":
          this.priceTagBackground = this.input.themes.priceTagBackground;
          break;
        case "sectionTitleColor":
          this.sectionTitleColor = this.input.themes.sectionTitleColor;
          break;
        case "listItemNameColor":
          this.listItemNameColor = this.input.themes.listItemNameColor;
          break;
        case "listItemPriceColor":
          this.listItemPriceColor = this.input.themes.listItemPriceColor;
          break;
        case "listItemDescriptionColor":
          this.listItemDescriptionColor = this.input.themes.listItemDescriptionColor;
          break;
        case "oddColor":
          this.oddColor = this.input.themes.oddColor;
          break;
        case "titleLetterColor":
          this.titleLetterColor = this.input.themes.titleLetterColor;
          break;
      }
    },
    async onSaveSetting() {
      await updateSetting("settings", {
        ...this.input
      });

      this.showSuccessMessage("Información de la empresa guardado");
    }
  }
};
</script>

<style scoped lang="scss">
.icons-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
  min-width: 100px;
}
.icons-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
